import { makeStyles } from '@mui/styles';

export const useCssClasses = makeStyles((theme: any) => ({
  root: {
    paddingBottom: '8px',
  },
  loginDescription: {
    flexDirection: 'column',
    '& span:first-of-type::after': {
      content: '""',
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      '& span:first-of-type::after': {
        content: '"\\a0"',
      },
    },
  },
}));
